// extracted by mini-css-extract-plugin
module.exports = {"flat-selector":"flat-selector__33nmE","selector-option":"selector-option__2xWYt","active":"active__1WTHW"};